import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            为什么选择吃瓜群
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">打造最好的免费吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((feature) => (
            <div key={feature.title} className="text-center p-6 rounded-lg bg-background-100/60 border border-background-200/70">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-800" style={{ fontFamily: 'var(--font-heading)' }}>
                {feature.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}